export default "__VITE_ASSET__14ef40d3__"